<template>
  <PageTemplate>
    <h1 v-text="title" />
    <div class="row">
      <div class="col-md-12 d-flex">
        <v-card title="Facility Details">
          <template #header>
            <router-link
              to="/contact"
            >
              <v-icon type="edit" />
              Edit
            </router-link>
          </template>
          <v-definition-list
            :data="facilityDetails"
          />
        </v-card>
      </div>
      <!-- <div class="col-md-6 d-flex">
        <v-card title="Authorised Representative">
          <v-definition-list
            :data="authorisedRep"
          />
        </v-card>
      </div> -->
    </div>
    <v-card title="Sites">
      <v-table
        :table="table"
      />
    </v-card>
  </PageTemplate>
</template>
<script>
import PageTemplate from "../templates/Page/index.vue";
import Card from "@/molecules/Card";
import Table from "@/molecules/Table";
import DefinitionList from "@/atoms/DefinitionList";
import Icon from "@/atoms/Icon";
import { columnFilter, columnSort, stateList,buildBreadCrumb,buildDefinitionList } from "../common/tableFunctions"
import routes from "@/common/routes"
import { GET_FACILITY } from "@/store/actions.type";

export default {
  name: "Facility",
  components: {
    "v-table": Table,
    "v-definition-list": DefinitionList,
    "v-card": Card,
    "v-icon": Icon,
    PageTemplate,
  },
  data(){
    return {
      title: 'Facility',
      breadcrumbs: [],
      table: {
        columns: [
          {
            label: 'Site Name',
            field: 'site_name',
            link: true,
            sortFn: columnSort,
            thClass: 'sortable',
            filterOptions: {
              enabled: true,
              placeholder: 'Search name',
              filterFn: columnFilter
            },
          },
          {
            label: 'Site Number',
            field: 'site_id',
            sortFn: columnSort,
            thClass: 'sortable',
            filterOptions: {
              enabled: true,
              placeholder: 'Site ID',
              filterFn: columnFilter
            },
          },
          {
            label: 'Status',
            field: 'site_status',
            badge: true,
            sortFn: columnSort,
            thClass: 'sortable',
            filterOptions: {
              enabled: true,
              placeholder: 'All',
              filterDropdownItems: ['In progress', 'Planned','Complete','Cancel'],
              filterFn: columnFilter
            },
          },
          {
            label: 'State',
            field: 'state',
            sortFn: columnSort,
            thClass: 'sortable',
            filterOptions: {
              enabled: true,
              placeholder: 'All',
              filterDropdownItems: stateList,
              filterFn: columnFilter
            },
          },
          {
            label: 'Suburb/City',
            field: 'suburb',
            sortFn: columnSort,
            thClass: 'sortable',
            filterOptions: {
              enabled: true,
              placeholder: 'Search suburb',
              filterFn: columnFilter
            }
          },
          {
              label: 'Actions',
              field: 'actions',
              actions: 'edit',
              sortable: false,
              thClass: 'shrink-cell',
            tdClass: 'no-wrap',
          }
        ],
        rows: [],
        totalRecords: 0
      },
      authorisedRep:[],
      facilityDetails:[]
    };
  },
  mounted() {
    this.getFacility(this.$route.params.id);
  },
  methods:{
    updateBreadCrumb: function(fn) {
       let breadcrumbs = [];
        breadcrumbs['Dashboard'] = routes.DASHBOARD;
        breadcrumbs['Facilities/Sites'] = routes.FACILITIES;
        breadcrumbs[this.title + ' - ' + fn ] = '';
        this.$store.dispatch('updateBreadCrumbAction', buildBreadCrumb(breadcrumbs));
    },
    getFacility: function(facility_id) {
      this.$store.dispatch(GET_FACILITY,{facility_id}).then(response => {
        let res = response.data;
        this.title = res[0].facility.name;
        this.updateBreadCrumb(res[0].facility.name);
        let authRep = [];
        let facilityDetails = [];


        facilityDetails['Facility Name'] = res[0].facility.name;
        facilityDetails['Facility Number'] = res[0].facility.facility_number;
        //TODO Fix once Contact details determined
        //facilityDetails['Phone'] = JSON.parse(res[0].facility.contacts).contacts[0].phone;
        facilityDetails['Email Address'] = res[0].facility.billing_email;
        facilityDetails['Address'] = res[0].facility.address;
        facilityDetails['Suburb'] = res[0].facility.suburb;
        facilityDetails['Post Code'] = res[0].facility.post_code;
        facilityDetails['State'] = res[0].facility.country !== null ? (res[0].facility.state + ', ' + res[0].facility.country):(res[0].facility.state);
        this.facilityDetails = buildDefinitionList(facilityDetails);

        //TODO Fix once Contact details determined
        //authRep['Name'] = JSON.parse(res[0].facility.contacts).contacts[0].name;
        //authRep['Phone number'] = JSON.parse(res[0].facility.contacts).contacts[0].phone;
        //authRep['Email Address'] = res[0].facility.billing_email;
        this.authorisedRep = buildDefinitionList(authRep);

        this.table.rows = this.formatSites(res);
        this.table.totalRecords = response.data.total;

        //filter unique status
        const arr = this.table.rows.map(i => i.status);
        this.table.columns[2].filterOptions.filterDropdownItems = Array.from([...new Set(arr.filter(
            function(el){
                return el != '-';
            }
        ))]);

        // //filter unique state
        const arr2 = this.table.rows.map(i => i.state.value);
        this.table.columns[3].filterOptions.filterDropdownItems  = Array.from([...new Set(arr2.filter(
            function(el){
                return el != '-';
            }
        ))]);
      });
    },
    formatSites: function(list){
      list.map((site) => {
        let site_name = {};
        let status = {};
        let site_id = {};
        let state = {};
        let suburb = {};

        site_id.value = site.site_number;
        site_name.value = site.name;
        site_name.link = routes.SITE + site.id;
        status.value = site.status;
        status.type = site.status === 'In Progress' ? 'accent':null;
        state.value = site.state;
        suburb.value = site.suburb;

        site.site_id = site_id;
        site.site_name = site_name;
        site.site_status = status;
        site.state = state;
        site.suburb = suburb;
      });
      return list;
    }
  }
}
</script>

